import moment from "moment"

export const imgPrefix = './static/assets/images/'

const CN_DATE_TIME_FORMAT = 'MM月DD日 HH:mm'

const DATE_FORMAT = 'YYYY-MM-DD'

const urlPrefixHttps = {
  prd: {
    ACTIVITY: 'https://www.zhi-niao.com/activity',
    APP: 'https://www.zhi-niao.com/app',
    ZN_LIVE: 'https://www.zhi-niao.com/znlive',
    ZN_WEB: 'https://www.zhi-niao.com/znWeb',
    OFFICIAL: 'https://www.zhi-niao.com',
    ADMIN: 'https://hrmsv3-mlearning-admin.pingan.com.cn'
  },
  test1: {
    ACTIVITY: 'https://test1.zhi-niao.com:10516/activity',
    APP: 'https://test1.zhi-niao.com:10516/app',
    ZN_LIVE: 'https://test1.zhi-niao.com:10516/znlive',
    ZN_WEB: 'https://test1.zhi-niao.com:10516/znWeb',
    OFFICIAL: 'https://test1.zhi-niao.com:10516',
    ADMIN: 'https://test1-hrmsv3-mlearning-admin.pingan.com.cn'
  },
  test5: {
    ACTIVITY: 'https://test5.zhi-niao.com:10518/activity',
    APP: 'https://test5.zhi-niao.com:10518/app',
    ZN_LIVE: 'https://test5.zhi-niao.com:10518/znlive',
    ZN_WEB: 'https://test5.zhi-niao.com:10518/znWeb',
    OFFICIAL: 'https://test5.zhi-niao.com:10518',
    ADMIN: 'https://test5-hrmsv3-mlearning-admin.pingan.com.cn'
  },
  test9: {
    ACTIVITY: 'http://api-stg9.zhi-niao.com/activity',
    APP: 'http://api-stg9.zhi-niao.com/app',
    ZN_LIVE: 'http://api-stg9.zhi-niao.com/znlive',
    ZN_WEB: 'http://api-stg9.zhi-niao.com/znWeb',
    OFFICIAL: 'http://api-stg9.zhi-niao.com',
    ADMIN: 'http://stg9-hrmsv3-mlearning-admin.pingan.com'
  }
}

const urlPrefixHttp = {
  prd: {
    ACTIVITY: 'http://www.zhi-niao.com/activity',
    APP: 'http://www.zhi-niao.com/app',
    ZN_LIVE: 'http://www.zhi-niao.com/znlive',
    ZN_WEB: 'http://www.zhi-niao.com/znWeb',
    OFFICIAL: 'http://www.zhi-niao.com',
    ADMIN: 'http://hrmsv3-mlearning-admin.pingan.com.cn'
  },
  test1: {
    ACTIVITY: 'http://test1.zhi-niao.com:10517/activity',
    APP: 'http://test1.zhi-niao.com:10517/app',
    ZN_LIVE: 'http://test1.zhi-niao.com:10517/znlive',
    ZN_WEB: 'http://test1.zhi-niao.com:10517/znWeb',
    OFFICIAL: 'http://test1.zhi-niao.com:10517',
    ADMIN: 'http://test1-hrmsv3-mlearning-admin.pingan.com.cn'
  },
  test5: {
    ACTIVITY: 'http://test5.zhi-niao.com:10519/activity',
    APP: 'http://test5.zhi-niao.com:10519/app',
    ZN_LIVE: 'http://test5.zhi-niao.com:10519/znlive',
    ZN_WEB: 'http://test5.zhi-niao.com:10519/znWeb',
    OFFICIAL: 'http://test5.zhi-niao.com:10519',
    ADMIN: 'http://test5-hrmsv3-mlearning-admin.pingan.com.cn'
  },
  test9: {
    ACTIVITY: 'http://test9.zhi-niao.com/activity',
    APP: 'http://test9.zhi-niao.com/app',
    ZN_LIVE: 'http://test9.zhi-niao.com/znlive',
    ZN_WEB: 'http://test9.zhi-niao.com/znWeb',
    OFFICIAL: 'http://test9.zhi-niao.com',
    ADMIN: 'http://stg9-hrmsv3-mlearning-admin.pingan.com'
  }
}

export const getPrefix = () => {
  const { host, protocol } = window.location
  const urlPrefix = protocol === 'http:' ? urlPrefixHttp : urlPrefixHttps
  if (host.includes('test1') || host.includes('test-stg1') || host.includes('console-stg1')) return urlPrefix.test1
  if (host.includes('test5') || host.includes('test-stg5') || host.includes('console-stg5')) return urlPrefix.test5
  if (host.includes('test9') || host.includes('stg9')) return urlPrefix.test9
  return urlPrefix.prd
}

export const getPrefixApp = () => {
  const { host, protocol } = window.location
  const urlPrefix = protocol === 'http:' ? urlPrefixHttp : urlPrefixHttps
  if (host.includes('stg1')) return urlPrefix.test1
  if (host.includes('stg5') || host.includes('localhost')) return urlPrefix.test5
  if (host.includes('stg9')) return urlPrefix.test9
  return urlPrefix.prd
}

const convertToMoment = (time): moment.Moment => {
  if (moment.isMoment(time)) return (time as moment.Moment)
  return moment(time)
}

export const toDate = time => convertToMoment(time).format(DATE_FORMAT)

export const toCNDateTime = time => convertToMoment(time).format(CN_DATE_TIME_FORMAT)
